import React, { useEffect, useMemo, useRef, useState } from "react";

const iconCache = new Map();

function TablerIcon({ name, size = 24, className = "" }) {
  const [svgMarkup, setSvgMarkup] = useState(iconCache.get(name) || "");
  const iconRef = useRef(null);

  const iconUrl = useMemo(() => {
    if (!name) return null;
    return `https://cdn.jsdelivr.net/npm/@tabler/icons@latest/icons/${name}.svg`;
  }, [name]);

  useEffect(() => {
    let mounted = true;

    async function loadIcon() {
      if (!name) return;
      if (iconCache.has(name)) {
        setSvgMarkup(iconCache.get(name));
        return;
      }

      if (!iconUrl) return;

      try {
        const response = await fetch(iconUrl);
        if (!response.ok) return;
        const markup = await response.text();
        iconCache.set(name, markup);
        if (mounted) setSvgMarkup(markup);
      } catch (error) {
        // Ignore icon fetch errors to avoid breaking UI.
      }
    }

    loadIcon();
    return () => {
      mounted = false;
    };
  }, [iconUrl, name]);

  // Match the original template behavior: adjust SVG size/stroke after injection.
  useEffect(() => {
    if (!svgMarkup) return;
    const el = iconRef.current;
    const svg = el?.querySelector("svg");
    if (!svg) return;

    svg.setAttribute("width", String(size));
    svg.setAttribute("height", String(size));
    svg.setAttribute("stroke-width", "1.5");
    svg.style.display = "inline-block";
    svg.style.verticalAlign = "middle";
    svg.style.stroke = "currentColor";
  }, [size, svgMarkup]);

  return (
    <i
      ref={iconRef}
      data-tabler={name}
      className={className}
      style={{ width: size, height: size }}
      dangerouslySetInnerHTML={svgMarkup ? { __html: svgMarkup } : undefined}
      aria-hidden="true"
    />
  );
}

export default TablerIcon;
